var CourseLog = {
    // The course log will save the log entries in local storage and every so often save the logs to the database
    // If the local log is up to date, nothing will happen
    // If it has changed and the next timed interval x seconds occurs it will be saved to the server db
    // If we get an additional y number of entries added, it will perform the check sooner and reset the
    // timer to x seconds from this point

    save_log_timer : null,
    save_log_time_interval : 10,
    save_log_entries_interval : 6,
    last_save : {
        updated : 0,
        entries_len : 0
    },

    init : function() {
        CourseLog.save_log_timer = setInterval(CourseLog.checkToSave, CourseLog.save_log_time_interval * 1000);
    },

    checkToSave : function()
    {
        let log = CourseLog.getLocalLog(Courses.currentCourse.uciID);
        console.log("Last updated: ", log.updated, CourseLog.last_save.updated, log.updated - CourseLog.last_save.updated);
        console.log("Entries: ", log.entries.length, CourseLog.last_save.entries_len, log.entries.length - CourseLog.last_save.entries_len);
        if (log.updated - CourseLog.last_save.updated > 0) {
            console.log("Should update because it's been a while");
        }

        if (log.entries.length - CourseLog.last_save.entries_len) {
            console.log("Should save because there have been a number of operations");
        }
    },

    getLocalLog : function(uciID)
    {
        let log = {};

        log[uciID] = {
            entries : [],
            updated : 0
        };

        if (localStorage.courseLog) {
            log = JSON.parse(localStorage.courseLog);
        }

        return log[uciID];
    },

    addEntry : function(logTypeID, entry)
    {
        // First get from the local storage
        let log_obj = {};
        let local_log = CourseLog.getLocalLog(Courses.currentCourse.uciID);
        let ts = (new Date()).getTime();

        let item = {
            logTypeID : logTypeID,
            entry : entry,
            ts : ts,
        };

        local_log.entries.push(item);
        local_log.updated = ts;
        log_obj[Courses.currentCourse.uciID] = local_log;

        localStorage.courseLog = JSON.stringify(log_obj);

        CourseLog.checkToSave();

        //var sendData = {
            //uciID : Courses.currentCourse.uciID,
            //logTypeID : logTypeID,
            //entry : entry,
        //};
        //// console.log(sendData);
        //$.ajax({
            //url: '/ajax/AJAX-course-log/add-entry',
            //type: 'post',
            //data: sendData,
            //dataType: 'json',
            //success: function ( returnedData ) {
                //// console.log(returnedData);
            //},
        //});
    },

    saveLog : function()
    {
        let log = CourseLog.getLocalLog(Courses.currentCourse.uciID);

        var sendData = {
            uciID : Courses.currentCourse.uciID,
            log : JSON.parse(log)
        };

        $.ajax({
            url: '/ajax/AJAX-course-log/save-log',
            type: 'post',
            data: sendData,
            dataType: 'json',
            success: function(returnedData) {
                // console.log(returnedData);
            },
        });
    }
};
